module.exports = __webpack_public_path__ + "static/media/Screenshot6.ba19eda1.png";